/**
 * Vuely Global Components
 */
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import AppSectionLoader from 'Components/AppSectionLoader/AppSectionLoader'
import { RotateSquare2 } from 'vue-loading-spinner'
import vueHeadful from 'vue-headful'
import VueLazyload from 'vue-lazyload'
import 'vue-tree-halower/dist/halower-tree.min.css' // you can customize the style of the tree
import VTree from 'vue-tree-halower'
import VueEasyLightbox from 'vue-easy-lightbox'
import VueMask from 'v-mask'
import DateTimePicker from 'vue-vanilla-datetime-picker'
import 'vue-vanilla-datetime-picker/dist/DateTimePicker.css'
// store
import { store } from '@/store/store';
// delete Confirmation Dialog
import DeleteConfirmationDialog from 'Components/DeleteConfirmationDialog/DeleteConfirmationDialog'

// page title bar
import PageTitleBar from 'Components/PageTitleBar/PageTitleBar'

// App Card component
import AppCard from 'Components/AppCard/AppCard'

// stats card
import StatsCard from 'Components/StatsCard/StatsCard'
import StatsCardV2 from 'Components/StatsCardV2/StatsCardV2'
import VueSocketIO from 'vue-socket.io-extended'
import SocketIO from "socket.io-client"
// section tooltip
import SectionTooltip from 'Components/SectionTooltip/SectionTooltip'

const GlobalComponents = {
    install(Vue) {
        Vue.component('appCard', AppCard)
        Vue.component('sectionTooltip', SectionTooltip)
        Vue.component('statsCard', StatsCard)
        Vue.component('statsCardV2', StatsCardV2)
        Vue.component('deleteConfirmationDialog', DeleteConfirmationDialog)
        Vue.component('vuePerfectScrollbar', VuePerfectScrollbar)
        Vue.component('appSectionLoader', AppSectionLoader)
        Vue.component('pageTitleBar', PageTitleBar),
        Vue.component('dateTimePicker', DateTimePicker),
        Vue.component('rotateSquare2', RotateSquare2),
            Vue.component('vue-headful', vueHeadful),
            Vue.use(VueEasyLightbox),
            Vue.use(VueLazyload),
            Vue.use(VTree),
            Vue.use(VueMask),
            Vue.use(VueSocketIO, SocketIO('https://routestatus.net'), { store })
    }
}

export default GlobalComponents